import { defineMessages } from "react-intl";
import { Workspace } from "../../contract/pam.js";
const localizedWorkspaces = defineMessages({
  [Workspace.Global]: {
    id: "workspaceGlobal",
    defaultMessage: "Blank"
  },
  [Workspace.Kyc]: {
    id: "workspaceKYC",
    defaultMessage: "KYC"
  },
  [Workspace.Payment]: {
    id: "workspacePayment",
    defaultMessage: "Payment"
  },
  [Workspace.Security]: {
    id: "workspaceSecurity",
    defaultMessage: "Security"
  },
  [Workspace.CustomerSupport]: {
    id: "workspaceCustomerSupport",
    defaultMessage: "Customer Support"
  },
  [Workspace.Fraud]: {
    id: "workspaceFraud",
    defaultMessage: "Fraud"
  },
  GlobalRead: {
    id: "workspaceGlobalRead",
    defaultMessage: "Global"
  }
});
export {
  localizedWorkspaces
};
//# sourceMappingURL=workspace.js.map
